module.exports = __webpack_public_path__ + "img/whatsapp.1da1618b.png";